import graphcmsSlice from "../slices/graphcmsSlice";

export const graphcmsReducers = {
  graphcms: graphcmsSlice,
};
